import HowTo from '../../images/HowTo.png';

function HowToUse() {
    return (
        <div style={{ marginLeft: '2.5px', marginRight: '20px', marginTop: '20px' }}>
            <img src={HowTo} style={{ width: '100%', height: '' }} alt="" />
        </div>
    );
}

export default HowToUse;